import { render, staticRenderFns } from "./SortContacts.vue?vue&type=template&id=0b24dea6&"
import script from "./SortContacts.vue?vue&type=script&lang=js&"
export * from "./SortContacts.vue?vue&type=script&lang=js&"
import style0 from "./SortContacts.vue?vue&type=style&index=0&id=0b24dea6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports